<template>
  <div>
    <section style="max-height: 80vh; overflow-y: scroll">
      <table class="table align-middle table-bordered table-hover">
        <thead class="table-primary">
          <tr class="text-capitalize">
            <th>title</th>
            <th>date</th>
            <th>status</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(room, index) in rooms" :key="index">
            <td class="text-body">
              <router-link
                :to="{ name: 'Room', params: { id: room.uid } }"
                custom
                v-slot="{ navigate }"
              >
                <span
                  role="link"
                  class="btn btn-link"
                  title="Go to the Topic"
                  @click="navigate"
                  aria-current="true"
                  @keypress.enter="navigate"
                >
                  {{ room.title }}
                </span>
              </router-link>
            </td>
            <td class="text-body">
              {{ room.created_at }}
            </td>
            <td class="text-body">
              <span v-if="room.status == 1">Enabled</span>
              <span v-else>Disabled</span>
            </td>
            <td class="text-body">
              <button
                @click="setCurrentRoom(room)"
                data-bs-toggle="modal"
                data-bs-target="#currentRoom"
                class="btn btn-link"
              >
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <nav aria-label="Page navigation text-end">
      <ul class="pagination" style="justify-content: flex-end">
        <li class="page-item">
          <button
            v-if="lastindexroom >= perPage"
            class="btn page-link"
            @click="loadRooms(false)"
          >
            Previous
          </button>
          <button v-else class="btn page-link disabled" disabled>
            Previous
          </button>
        </li>

        <li v-for="i in countOfPages" :key="i" class="page-item">
          <span
            class="page-link"
            v-bind:class="currentPage == i ? 'text-danger' : false"
            >{{ i }}</span
          >
        </li>

        <li class="page-item">
          <button
            v-if="countOfPages > currentPage"
            @click="loadRooms(true)"
            class="btn page-link"
          >
            Next
          </button>
          <button v-else class="btn page-link disabled" disabled>Next</button>
        </li>
      </ul>
    </nav>

    <div
      class="modal fade"
      id="currentRoom"
      tabindex="-1"
      aria-labelledby="currentRoomLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div v-if="currnetRoom" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="currentRoomLabel">
              {{ currnetRoom.name }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="status" class="form-label">Status</label>
              <select
                class="form-select"
                v-model="status"
                aria-label="Default select example"
              >
                <option value="0">Disabled</option>
                <option value="1">Enabled</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              <span @click="changeRoomStatus">Yes</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminRooms",

  data() {
    return {
      rooms: [],
      status: undefined,
      lastindexroom: 0,
      currentPage: 1,
      perPage: 10,
      countOfPages: 0,
      currnetRoom: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadRooms(null);
    });
  },
  methods: {
    loadRooms(directive) {
      if (directive != null) {
        if (directive) {
          this.lastindexroom += this.perPage;
          this.currentPage++;
        } else {
          this.lastindexroom -= this.perPage;
          this.currentPage--;
        }
      }

      this.$store.state.modules.api
        .getAllRoomsForAdmin(
          JSON.parse(localStorage.account).token,
          this.lastindexroom,
          this.perPage
        )
        .then((resp) => {
          this.rooms = resp.data.rooms;
          this.countOfPages = resp.data.countOfPages;
        });
    },

    setCurrentRoom(user) {
      this.currnetRoom = user;
      this.status = user.status;
    },

    changeRoomStatus() {
      this.$store.state.modules.api
        .changeRoomStatus(
          this.currnetRoom.uid,
          this.status,
          JSON.parse(localStorage.account).token
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                message: "success deleted room",
              },
              2500
            );
            this.loadRooms(null);
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "warning room",
              },
              2500
            );
          }
        });
    },
  },
};
</script>
